import { computed, getCurrentInstance } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { handleRequestError } from "@/lib/handleRequestError";
import config from "@/config";
import { ERRORS, EVENTS } from "@/const";

export default function useNSFWUserSettings() {
  const vm = getCurrentInstance();
  const { authUser } = useAuthUser();

  const nSFWUserSettings = computed(() => (vm ? (vm.$store.state as StateRoot).nSFWUserSettings ?? null : null));
  const showNotSafeForWork = computed(() => (!config.featureNSFW ? true : !!nSFWUserSettings.value));

  const updateNSFWUserSettings = async (value: boolean) => {
    if (!authUser.value) return;
    try {
      providers.NSFWSettingsProvider.setReceiveErrors(false);
      const response = await providers.NSFWSettingsProvider.updateUserSettings({
        data: { userId: authUser.value?.id, showNotSafeForWork: value },
      });
      vm?.$store.commit(MUTATION_TYPES.SET_NSFW_USER_SETTING, response.showNotSafeForWork);
    } catch (e) {
      handleRequestError(e, [
        {
          comparator: e => e.details?.messageTemplate === ERRORS.NSFW_USER_SETTING_ENABLE_RESTRICTED,
          onSuccessCB: () => emitter.emit(EVENTS.AGE_VERIFICATION_START),
        },
      ]);
      throw e;
    }
  };

  return {
    showNotSafeForWork,
    nSFWUserSettings,
    updateNSFWUserSettings,
  };
}
